import appFleet from "../../views/appFleet/index.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("fleet", {
    url: "fleet?page&limit",
    parent: "app",
    views: {
      view: {
        template: appFleet,
      },
    },
    reloadOnSearch: false,
    data: { title: "Fleet" + constants.titleBase },
    onEnter: [
      "$state",
      function ($state) {
        $state.go("buses"); // Replace 'newState' with the name of the state you want to redirect to
      },
    ],
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.urls.js